import { render, staticRenderFns } from "./product-purchase-process.vue?vue&type=template&id=70c0d0e0&"
import script from "./product-purchase-process.vue?vue&type=script&lang=js&"
export * from "./product-purchase-process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports